// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file inventory/update_inventory_metadata.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { ItemMetadata, ItemType } from "./common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.UpdateInventoryMetadataRequest
 */
export class UpdateInventoryMetadataRequest extends Message<UpdateInventoryMetadataRequest> {
  /**
   * Unique identifier for the inventory item
   *
   * @generated from field: string inventory_id = 1;
   */
  inventoryId = "";

  /**
   * Metadata to update for the inventory item
   *
   * @generated from field: com.neulink.pharmacy.ItemMetadata metadata = 2;
   */
  metadata?: ItemMetadata;

  /**
   * Type of the item being updated (e.g., drug, medical equipment)
   *
   * @generated from field: com.neulink.pharmacy.ItemType item_type = 3;
   */
  itemType = ItemType.UNSPECIFIED;

  constructor(data?: PartialMessage<UpdateInventoryMetadataRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.UpdateInventoryMetadataRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "inventory_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "metadata", kind: "message", T: ItemMetadata },
    { no: 3, name: "item_type", kind: "enum", T: proto3.getEnumType(ItemType) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateInventoryMetadataRequest {
    return new UpdateInventoryMetadataRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateInventoryMetadataRequest {
    return new UpdateInventoryMetadataRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateInventoryMetadataRequest {
    return new UpdateInventoryMetadataRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateInventoryMetadataRequest | PlainMessage<UpdateInventoryMetadataRequest> | undefined, b: UpdateInventoryMetadataRequest | PlainMessage<UpdateInventoryMetadataRequest> | undefined): boolean {
    return proto3.util.equals(UpdateInventoryMetadataRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.UpdateInventoryMetadataResponse
 */
export class UpdateInventoryMetadataResponse extends Message<UpdateInventoryMetadataResponse> {
  constructor(data?: PartialMessage<UpdateInventoryMetadataResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.UpdateInventoryMetadataResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateInventoryMetadataResponse {
    return new UpdateInventoryMetadataResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateInventoryMetadataResponse {
    return new UpdateInventoryMetadataResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateInventoryMetadataResponse {
    return new UpdateInventoryMetadataResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateInventoryMetadataResponse | PlainMessage<UpdateInventoryMetadataResponse> | undefined, b: UpdateInventoryMetadataResponse | PlainMessage<UpdateInventoryMetadataResponse> | undefined): boolean {
    return proto3.util.equals(UpdateInventoryMetadataResponse, a, b);
  }
}

